import { useState, useEffect } from 'react'
import Dashboard from './dashboard'
import { useQuery } from '@apollo/client'
import { COACH_ONBOARDING_PROGRESS } from './query'
import Error from 'components/error'
import LoadingSkeleton from './loadingSkeleton'
import { makeSteps } from './dashboardUtils'
import { useChatContext } from 'stream-chat-react'
import { withStreamClient } from 'lib/stream-messaging'

const DashboardPage = withStreamClient(() => {
  const [hasMessages, setHasMessages] = useState(false)

  const { client } = useChatContext()

  useEffect(() => {
    const getChannels = async () => {
      const filters = { members: { $in: [client.user?.id] } }
      try {
        const { results } = await client.search(
          filters,
          { 'user.id': client.user?.id },
          { limit: 1, offset: 0 },
        )
        setHasMessages(results.length > 0)
      } catch (e) {
        setHasMessages(false)
      }
    }
    getChannels()
  }, [client])

  const { data, loading, error } = useQuery(COACH_ONBOARDING_PROGRESS)

  if (loading) return <LoadingSkeleton />
  if (error) return <Error />

  const { steps, progress } = makeSteps(data, hasMessages)
  const currentOpenStep = steps.find(({ isComplete }) => !isComplete)

  return (
    <Dashboard
      steps={steps}
      progress={progress}
      currentOpenStep={currentOpenStep}
    />
  )
})

export default DashboardPage
